(function organizationalUnitFindControllerDefinition() {
    'use strict';

    angular.module('OrganizationalUnit')
        .controller('OrganizationalUnitFindController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', 'adminOrganizationalUnitService', 'authExtend', 'organizartionalUnitAction', 'alerts', '$q',
            function organizationalUnitFindController($scope, config, $state, $translate, errors, adminOrganizationalUnitService, authExtend, organizartionalUnitAction, alerts, $q) {
                $scope.find =
                    {
                        Name: '',
                        showNoData: false,
                        isRoot: undefined
                    };

                $scope.organizationalUnits = [];
                $scope.hideAddBtn = !authExtend.isInRole('ORGANIZATIONALUNIT CREATE');
                $scope.hideEditBtn = !authExtend.isInRole('ORGANIZATIONALUNIT WRITE');
                $scope.enabledRootOus = authExtend.getOrganizationId() ? false : true;
                $scope.enableDisableBtn = authExtend.isInRole('ORGANIZATIONALUNIT ENABLED DISABLED');
                $scope.hideRemoveBtn = !authExtend.isInRole('ADMIN HARD DELETE');
                $scope.enableviewIndex = authExtend.isInRole('VIEW INDEX') || authExtend.isInRole('EDIT AND DELETE INDEX');
                $scope.find = function () {

                    $scope.find.showNoData = false;

                    return adminOrganizationalUnitService.get(
                        $scope.find.Name,
                        undefined,
                        undefined,
                        $scope.find.isRoot,
                        $scope.data.currentPage,
                        $scope.data.itemsPerPage
                    ).then(function getOk(result) {
                        $scope.organizationalUnits = result.value;
                        $scope.data.totalItems = result.totalCount;
                        $scope.data.from = 1 + ($scope.data.itemsPerPage * ($scope.data.currentPage - 1));
                        if ($scope.organizationalUnits.length === 0)
                            $scope.find.showNoData = true;
                    }, function getError(error) {
                        errors.showError(error);
                    });
                };

                $scope.modify = function (organizationalUnit) {
                    $state.go('organizational-unit-modify', { id: organizationalUnit.id });
                };

                $scope.add = function () {
                    $state.go('organizational-unit-add');
                };

                $scope.view = function (organizationalUnit) {
                    $state.go('organizational-unit-detail', { id: organizationalUnit.id });
                };

                $scope.enable = function (ou, index) {
                    return organizartionalUnitAction.enable(ou).then(function getOk() {
                        $scope.find();
                    });
                };

                $scope.disable = function (ou, index) {
                    return organizartionalUnitAction.disable(ou).then(function getOk() {
                        $scope.find();
                    });
                };

                $scope.viewIndex = function (organizationalUnit) {
                    $state.go('dba-detail', { key: 'OU', id: organizationalUnit.id });
                };

                $scope.hardRemove = function (ou) {
                    $translate(['Warning', 'HardDelteConfirmText', 'Yes', 'No']).then(function (translated) {
                        return alerts.confirm(translated.Warning, translated.HardDelteConfirmText, translated.Yes, translated.No).then(function getOk(result) {
                            if (!result) {
                                defered.reject();
                                return result;
                            }

                            var promises = [adminOrganizationalUnitService.removeEdr(ou.id), adminOrganizationalUnitService.removeWf(ou.id), adminOrganizationalUnitService.removeAudit(ou.id)];
                            $q.all(promises).then(function (value) {
                                adminOrganizationalUnitService.removeAuth(ou.id).then(function getOk(result) {
                                }, function getError(error1) {
                                    errors.showError(error1);
                                });
                            }, function error(error) {
                                errors.showError(error);
                            });
                        });
                    });

                    return;
                };

                $scope.load = function () {
                    $scope.data = {
                        currentPage: 1,
                        totalItems: 0,
                        itemsPerPage: 15,
                        from: 0
                    };

                    $translate(['PaginationNext', 'PaginationPrev', 'PaginationLastFem', 'PaginationFirstFem'])
                        .then(function (translated) {
                            $scope.paginatorTranslations = {
                                nextText: translated.PaginationNext,
                                previousText: translated.PaginationPrev,
                                lastText: translated.PaginationLastFem,
                                firstText: translated.PaginationFirstFem
                            };
                        });
                    $scope.find();
                }

                $scope.load();
            }
        ]);
})();